import ScheduleColumnManager from '../../schedules/ScheduleColumnManager';

export default class AggregableColumnManager extends ScheduleColumnManager {
  constructor(session, counterparty) {
    super(session, counterparty);

    this.settings.grouping = {
      scheduleDate: {
        groupIndex: 0,
        sortOrder: 'asc'
      }
    };

    this.settings.sizing = {
      contractDisplayName: {
        width: 135
      }
    };
  }

  addLeadingColumns(columns) {
    super.addLeadingColumns(columns);

    this.addColumn(columns, {
      alignment: 'left',
      allowEditing: false,
      allowFiltering: true,
      allowHiding: true,
      allowResizing: true,
      dataType: 'string',
      caption: 'Contract',
      dataField: 'contractDisplayName',
      visible: true,
      width: 80
    });
  }

  addIntermediateColumns(columns) {
    super.addIntermediateColumns(columns);
  }

  addTrailingColumns(columns) {
    super.addTrailingColumns(columns);

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Total (Hours)',
      dataField: 'totalH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 95
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Total (MWh)',
      dataField: 'totalMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: true,
      width: 95
    });
  }

  getColumnCssClass() {
    return 'pwx-alert-overlay-none pwx-flag-none pwx-select-none pwx-state-normal pwx-highlight-none pwx-cell-standard';
  }
}